module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-popup', {
    staticClass: "common-qifu-pop",
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('div', {
    staticClass: "pop-content"
  }, [_c('button', {
    staticClass: "open-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadLjdsApp
    }
  })])]), _vm._v(" "), _c('commonLjdsDownload', {
    ref: "download",
    attrs: {
      "tag": _vm.dlTag
    },
    on: {
      "getDownloadLink": _vm.getDownloadLink
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b19a769", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b19a769","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/commonQifuPop.vue
// module id = 411
// module chunks = 32